import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

const Title = styled(Typography)(({ theme }) => ({
  padding: '11px 25px 10px',
  fontSize: 24,
  textAlign: 'center',
  borderBottom: '1px solid #d6d6d6',
  [theme.breakpoints.down('md')]: {
    lineHeight: '34px'
  },
  [theme.breakpoints.down('sm')]: {
    textAlign: 'left'
  }
}));

const ContentWrapper = styled('div')(() => ({
  padding: '20px 25px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start'
}));

const Text = styled(Typography)(({ theme }) => ({
  color: theme.palette.textPrimary.main,
  fontSize: 16,
  lineHeight: 1.6
}));

const ScheduleSlideComponent = ({ professionInfo, t }) => {
  const workEnvironment = professionInfo?.workEnvironment;
  
  // Hide component if workEnvironment is empty or missing
  if (!workEnvironment || !workEnvironment.trim()) {
    return null;
  }

  return (
    <>
      <Title variant={'h1'}>{t('Schedule')}</Title>
      <ContentWrapper>
        <Text variant="body1">{workEnvironment}</Text>
      </ContentWrapper>
    </>
  );
};

export default ScheduleSlideComponent;
